import './public-path' //do not remove this public-path import - used for cdn url in app
import 'es6-promise/auto';
import Vue from 'vue'
import Logger from "@/utils/logger"
import CurrencyFilter from "@/filters/currency"
import dompolyfills from "@/utils/dom-polyfills.js"
import vendorpolyfills from "@/utils/vendor-polyfills.js"
import formHelpers from "@/directives/form.js"
import reportError from "@/directives/report-error.js"
import CBStyleConfig from '@/directives/styles.js'
// import ToggleButton from 'vue-js-toggle-button'
import CbSlide from "@/transitions/cb-slide"
import CbAnimate from "@/transitions/cb-animate"
import SlideNFadeTransition from "@/transitions/SlideNFadeTransition"
import ToggleAnimation from "@/transitions/ToggleAnimation"
import cbStorage from "@/utils/cb-storage"
import CbLink from "@/directives/cb-link"
import Vhtml from "@/directives/vhtml"
import ImportHelper from '@/utils/chunkImportWrapper'
import { CDN } from '@/components/modules/hosted-pages/LazyLoadPaymentComponents'
import RecaptchaUtil from '@/utils/recaptcha';

window.addEventListener("beforeunload", function(e) {
  // Disabling frame unload event, until preview portal is fixed in UI
  // window.cbPostMessage("cb.frameunload")
})
// Vue.use(ToggleButton)com
Vue.config.productionTip = false
Vue.use(formHelpers);


var isMobileOrTablet = function() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}
const isMobileResolution = ()=>{
  return window.innerWidth <= 480 || window.innerHeight <= 480;
}

window.isMobile = isMobileOrTablet();

window.isMobileResolution = isMobileResolution();

window.cbTimeout = (func, timer) => {
  return window.setTimeout(() => {
    try {
      func();
    }
    catch(error) {
      window.logger.e(error);
    }
  }, timer);
}

window.cbPostMessage = function(event, referrerDomain) {
  let domain = referrerDomain ? referrerDomain : "*";
  if(window.parent != window){
    window.parent.postMessage(event, domain);
  }
  else {
    if(window.opener) {
      window.opener.postMessage(event, domain);
    }
  }
}

window.cbReload = function() {
  if(window.isOpenedByCb || window.cbReferrer) {
    let queryToAppend = "";
    if(window.isOpenedByCb) {
      queryToAppend += "hp_opener=chargebee";
    }
    if(window.cbReferrer) {
      queryToAppend += `${queryToAppend ? '&': ''}hp_referrer=${window.cbReferrer}`;
    }
    if(document.location.search.startsWith("?")) {
      document.location.search += queryToAppend;
    }
    else {
      document.location.search += `&${queryToAppend}`;
    }
  }
  else {
    window.location.reload();
  }
}

window.logger = new Logger(Logger.DEBUG, true, window.initInfo && window.initInfo.sentry);
Vue.use(reportError);
window.cbStorage = cbStorage;

Vue.filter('cbCurrency', CurrencyFilter);
Vue.use(CBStyleConfig);
Vue.directive('cb-slide', CbSlide);
Vue.component('cb-slide-n-fade',SlideNFadeTransition);
Vue.component('cb-toggle',ToggleAnimation);
Vue.directive('cb-animate', CbAnimate)
Vue.directive('cb-link', CbLink);
Vue.directive('cb-html', Vhtml);

function loadDependencies() {
  if(!window.mapsLoaded) {
    window.mapsLoaded = function() {
      window.googleMapsLoaded = true
    }
  }
  if(window.initInfo && window.initInfo.google_maps_apikey) {
    let key = window.initInfo.google_maps_apikey
    ImportHelper.loadScript(`https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&callback=mapsLoaded`, null, () => !!(window.google && window.google.maps))
      .catch(e => e ? window.logger.e(e) : window.logger.e(new Error('Error loading Google Maps API')))
  }

  // Load Chargebee.js by default
  window.cbjsLoader = ImportHelper.loadScript(CDN.chargebeejs, null, 'Chargebee').then(() => {
    const cbjsInitOptions = {
      site: window.initInfo.site, 
      domain: window.location.origin,
      locale: window.initInfo.init_info_locale,
      cspNonce: window._hp_csp_nonce
    }
    Chargebee.init(cbjsInitOptions);
  }).then(() => {
    const cbInstance = Chargebee.getInstance();
    if (cbInstance && RecaptchaUtil.isRecaptchaEnabled()) {
      cbInstance.initializeCaptcha({
        siteKey: window.initInfo.captcha_site_key || window.initInfo.recaptcha_site_key,
        provider: window.initInfo.captcha_provider,
        isGlobalRecaptcha: RecaptchaUtil.isRecaptchaGloballySupported(),
      });
    }
  });
}

loadDependencies()

window.debounce = function debounce(func, wait, immediate) {
  var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) {
        func.apply(context, args);
      }
		};
		var callNow = immediate && !timeout;
    clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) {
      func.apply(context, args);
    }
	};
};